import React, { useState, useEffect, useContext } from "react";
import { Container, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";
import PdfViewerModal from "../../utils/PdfViewerModal";
import EditDocumentModal from "./EditDocument";
import { AuthContext } from "../../Context/AuthContext";
import Preloader from "../../shared/PreLoaders";

const ViewDocument = () => {
  const [documents, setDocuments] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [editModalShow, setEditModalShow] = useState(false);
  const [documentToEdit, setDocumentToEdit] = useState(null);
  const { permissions } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    setLoading(true);
    const fetchDocuments = async () => {
      try {
        const response = await axios.get(`${Api}/api/documents/documents`);
        setDocuments(response.data);
      } catch (error) {
        console.error("Error fetching documents", error);
        toast.error("Error fetching documents");
      }
      setLoading(false);
    };
    fetchDocuments();
  }, []);

  const handlePdfClick = (pdfUrl) => {
    setSelectedPdf(pdfUrl);
    setModalShow(true);
  };

  const handleEditDocument = (doc) => {
    setDocumentToEdit(doc);
    setEditModalShow(true);
  };

  const handleSaveEdit = async (updatedDocument) => {
    try {
      await axios.put(
        `${Api}/api/documents/${updatedDocument._id}`,
        updatedDocument
      );
      setDocuments((prevDocuments) =>
        prevDocuments.map((doc) =>
          doc._id === updatedDocument._id ? updatedDocument : doc
        )
      );
      toast.success("Document updated successfully");
      setEditModalShow(false);
    } catch (error) {
      console.error("Error updating document", error);
      toast.error("Error updating document");
    }
  };

  const handleDeleteDocument = async (id) => {
    if (window.confirm("Are you sure you want to delete this document?")) {
      try {
        await axios.delete(`${Api}/api/documents/documents/${id}`);
        setDocuments((prevDocuments) =>
          prevDocuments.filter((doc) => doc._id !== id)
        );
        toast.success("Document deleted successfully");
      } catch (error) {
        console.error("Error deleting document", error);
        toast.error("Error deleting document");
      }
    }
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div>
      <Preloader loading={loading} />

      <div className="page-header">
        <h3 className="page-title"> Documents </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Documents
            </li>
          </ol>
        </nav>
      </div>

      <Container>
        <div className="card">
          <div className="card-body">
            <div className="row icons-list">
              <div className="Table_data">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>SI No</th>
                      <th>VFC Name</th>
                      <th>Range</th>
                      <th>Document Name</th>
                      <th>Document Type</th>
                      <th>Document No</th>
                      <th>Date</th>
                      <th>Details</th>
                      <th>Uploaded Document</th>
                      {permissions.includes("EditDocs") &&
                        permissions.includes("DeleteDocs") && <th>Actions</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {documents.map((doc, index) => (
                      <tr key={doc._id}>
                        <td>{index + 1}</td>
                        <td>{doc.vfcId?.vfcName}</td>
                        <td>{doc.rangeId?.rangeName}</td>
                        <td>{doc.documentName}</td>
                        <td>{doc.documentType}</td>
                        <td>{doc.documentNo}</td>
                        <td>{formatDate(doc.date)}</td>
                        <td>{doc.details}</td>
                        <td>
                          <a
                            href={`${Api}/${doc.uploadDocument.replace(
                              "\\",
                              "/"
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Document
                          </a>
                        </td>
                        {permissions.includes("EditDocs") &&
                          permissions.includes("DeleteDocs") && (
                            <td>
                              <i
                                className="mdi mdi-pen"
                                style={{
                                  fontSize: "1.5rem",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleEditDocument(doc)}
                              />

                              <i
                                className="mdi mdi-delete"
                                style={{
                                  fontSize: "1.5rem",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleDeleteDocument(doc._id)}
                              />
                            </td>
                          )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>

        <PdfViewerModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          pdfUrl={selectedPdf}
        />

        <EditDocumentModal
          show={editModalShow}
          onHide={() => setEditModalShow(false)}
          document={documentToEdit}
          onSave={handleSaveEdit}
        />
      </Container>
    </div>
  );
};

export default ViewDocument;
